import { Emoji } from '../emoji/emoji';
import { container, description, emoji, title } from './ChartError.css';

export function ChartError() {
  return (
    <div className={container}>
      <div className={emoji}>
        <Emoji emoji="🤕" ariaLabel="oh-oh" />
      </div>
      <div className={title}>Yikes</div>
      <div className={description}>There was an error loading the data.</div>
    </div>
  );
}

export default ChartError;
